import React, { ReactNode } from 'react';
import HelpArticleButton from 'utils/HelpArticleButton';
import { Switch } from 'antd';
import cx from 'classnames';
import styles from './index.module.css';

type SettingSectionProps = {
  title: string;
  helpArticleId?: string;
  children: ReactNode;
};

export const SettingSection: React.FC<SettingSectionProps> = ({
  title,
  helpArticleId,
  children
}) => (
  <section className={styles.section}>
    <div className={styles.sectionHeader}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {helpArticleId && <HelpArticleButton articleId={helpArticleId} />}
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

type SettingRowProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  description?: ReactNode;
  meta?: ReactNode;
  helpArticleId?: string;
  loading?: boolean;
  disabled?: boolean;
  switchTitle?: string;
};

export const SettingRow: React.FC<SettingRowProps> = ({
  checked,
  onChange,
  label,
  description,
  meta,
  helpArticleId,
  loading,
  disabled,
  switchTitle
}) => (
  <div
    className={cx(styles.settingRow, {
      [styles.settingRowWithDescription]: description
    })}
  >
    <Switch
      className={styles.settingSwitch}
      checked={checked}
      loading={loading}
      disabled={disabled}
      onChange={onChange}
      title={switchTitle}
    />
    <div className={styles.settingContent}>
      <div className={styles.settingLabel}>
        <span>{label}</span>
        {helpArticleId && <HelpArticleButton articleId={helpArticleId} />}
      </div>
      {description && <p className={styles.settingDescription}>{description}</p>}
      {meta && <div className={styles.settingMeta}>{meta}</div>}
    </div>
  </div>
);
